import { IFile } from "../UI/FileList";
import { IOldAction } from "../components/ServiceOldActionsPanel/ServiceOldActionsPanel";
import { IAccess } from "./iaccess";
import { IPhoto, emptyPhoto } from "./iphoto";
import { IServiceQuestion } from "./iserviceQuestion";

export interface IService {
  _id: string,
  tenant: string,
  inspectedBy: {
    _id: string,
    name: string,
    access: IAccess[],
  },
  date: string,
  expirationDate: string,
  place: {
    _id: string,
    name: string,
    path: string,
  },
  equipment: {
    _id: string,
    equipmentModel: {
      _id: string,
      name: string,
    },
    serialNumber: string,
    photo: IPhoto,
  },
  description: string,
  deleted: boolean,
  equipmentService: {
    _id: string,
    expirationOnLastDayOfMonth: boolean,
    mandatoryActionsForNotComplyQuestions: boolean,
    frequency: {
      _id: string,
      name: string,
      amount: number,
      type: string,
      onDemand: boolean,
    },
    serviceType: {
      _id: string,
      name: string,
    }
  },
  files: IFile[],
  questions: IServiceQuestion[],
  delayAmount: number,
  doneInDelay: boolean,
  latitude: string,
  longitude: string,
  source: string,
  signature?: {
    name: string,
    document?: string,
    file: IFile,
    complement?: string,
  },
  checklistScore: number,
  checklistScoreFloat: number,
  oldActions: IOldAction[],
  totalActions: number,
  completedActions: number,
  mandatoryActionsForNotComplyQuestions: boolean,
  createdAt?: string,
  signatures?: { name: string, document?: string, file: IFile, complement?: string }[],
}

export const emptyService: IService = {
  _id: '',
  tenant: '',
  inspectedBy: {
    _id: '',
    name: '',
    access: [],
  },
  date: '',
  expirationDate: '',
  place: {
    _id: '',
    name: '',
    path: '',
  },
  equipment: {
    _id: '',
    equipmentModel: {
      _id: '',
      name: '',
    },
    serialNumber: '',
    photo: emptyPhoto,
  },
  description: '',
  deleted: false,
  equipmentService: {
    _id: '',
    expirationOnLastDayOfMonth: false,
    mandatoryActionsForNotComplyQuestions: false,
    frequency: {
      _id: '',
      name: '',
      amount: 0,
      type: '',
      onDemand: false,
    },
    serviceType: {
      _id: '',
      name: '',
    }
  },
  files: [],
  questions: [],
  delayAmount: 0,
  doneInDelay: false,
  latitude: '',
  longitude: '',
  source: '',
  checklistScore: 0,
  checklistScoreFloat: 0,
  oldActions: [],
  totalActions: 0,
  completedActions: 0,
  mandatoryActionsForNotComplyQuestions: false,
  signatures: [],
}